import { useCallback, useEffect, useState } from "react";
import offerApi from "../../../services/offerApi";

/**
 * Fetches the offer config for a given slug. No cache, no retry beyond
 * an explicit reload() call — a stale cached plan is worse than a brief
 * loading flash on this checkout page.
 */
export default function useOfferConfig(offerSlug) {
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!offerSlug) {
      setError({ message: "Missing offer slug", status: 400 });
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await offerApi.getOfferConfig(offerSlug);
      setOffer(data);
    } catch (err) {
      setError(err);
      setOffer(null);
    } finally {
      setLoading(false);
    }
  }, [offerSlug]);

  useEffect(() => {
    load();
  }, [load]);

  return { offer, loading, error, reload: load };
}
